<!--
 * @message:  可自定义样式下拉框
 * @Author: cjc
 * @since: 2019-11-04 11:28:22
 * @lastTime     : 2019-12-19 09:56:39
 * @LastAuthor   : cjc
 -->
<template>
  <div class="input-item">
    <div class="select-item">
      <div class="btn select" @click="showList">
        <img :class="'font ' + currSelect.class" src="@/assets/images/img_trans.png" />
        <a class="btn select_icon"></a>
      </div>
      <ul class="option-list" v-show="isShow">
        <li @click="handlerSelect(item)" v-for="(item, index) in list" :key="index">
          <img :class="'font ' + item.class" src="@/assets/images/img_trans.png" />
        </li>
      </ul>
    </div>
    <div class="input-item">
      <input @change="emitAreaCode" type="text" class="holder" maxlength="4" :value="currSelect.areaCode" :disabled="currSelect.disabled" placeholder="区号">
      <input @change="emitNumber" maxlength="15" class="btn input" type="text" name="tel" id="tel" placeholder="请输入手机号码"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-item',
  data () {
    return {
      isShow: false,
      list: [
        {
          name: '马来西亚',
          class: 'mlxy',
          areaCode: '+60',
          disabled: true
        },
        {
          name: '新加坡',
          class: 'xjp',
          areaCode: '+65',
          disabled: true
        },
        {
          name: '其他',
          class: 'other',
          areaCode: '',
          disabled: false
        }
      ],
      currSelect: {}
    }
  },
  created () {
    this.currSelect = JSON.parse(JSON.stringify(this.list[0]))
    this.currSelect.number = null
  },
  methods: {
    showList () {
      this.isShow = !this.isShow
      let icon = document.getElementsByClassName('select-item')[0].getElementsByTagName('a')[0]
      icon.style.transform = this.isShow ? 'rotate(180deg)' : 'rotate(0deg)'
    },
    handlerSelect (value) {
      Object.assign(this.currSelect, value)
      this.$emit('input', this.currSelect)
      this.isShow = false
    },
    emitNumber (e) {
      this.currSelect.number = e.target.value
      this.$emit('input', this.currSelect)
    },
    emitAreaCode (e) {
      let value = e.target.value
      if (value) {
        value.includes('+') || (value = '+' + value)
        this.currSelect.areaCode = value
        this.$emit('input', this.currSelect)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/variable.scss";
@import "../assets/styles/mixins.scss";

.input-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 450px;
  .select-item {
    position: relative;
    width: 143px;
    .select {
      position: relative;
      text-align: start;
      box-sizing: border-box;
      padding-left: 10px;
      a {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .option-list {
      position: absolute;
      top: 54px;
      left: 0;
      width: 100%;
      z-index: $menu-layer;
      padding-bottom: 5px;
      background-color: #fff;
    }
  }
  .input-item {
    position: relative;
    width: 281px;
    margin-left: 10px;
    .holder {
      position: absolute;
      left: 0;
      top: 0;
      width: 80px;
      font-size: 20px;
      text-indent: 10px;
      color: $font-color;
      line-height: 54px;
      background-color: transparent;
    }
    .input {
      box-sizing: border-box;
      padding-left: 56px;
      font-size: 24px;
      color: $font-color;
    }
    .input::-webkit-input-placeholder,
    .holder::-webkit-input-placeholder {
      font-size: 20px;
      color: $font-color;
    }
    .input::-moz-placeholder,
    .holder::-moz-placeholder {
      font-size: 20px;
      color: $font-color;
    }
    .input:-ms-input-placeholder,
    .hover:-ms-input-placeholder {
      font-size: 20px;
      color: $font-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/input.vue